import React, { useState } from 'react';
import NomineeLoginStep01 from './NomineeLoginStep01';
import NomineeLoginStep02 from './NomineeLoginStep02';
import NomineeLoginStep03 from './NomineeLoginStep03';

const NomineeLogin = ({ onAuthSuccess }) => {
  const [accounts, setAccounts] = useState([]);
  const [selectedAccountId, setSelectedAccountId] = useState('');
  const [step, setStep] = useState(1); // 1: request password, 2: select account & enter password

  const handleNomineeLogin = (result) => {
    setAccounts(result.users);
    setStep(2);
  }

  const handleAccountSelect = (accountId) => {
    setSelectedAccountId(accountId);
    sessionStorage.setItem('userId', accountId);
    setStep(3);
  };

  const handleBackToLogin = () => {
    setSelectedAccountId('');
    setAccounts([]);
    setStep(1);
  };

  const handleFileUploadAndVerified = (account) => {
    sessionStorage.setItem('email', account.email);
    sessionStorage.setItem('userId', account.id);
    sessionStorage.setItem('role', account.role);
    sessionStorage.setItem('isLoggedIn', 'true');
    
    onAuthSuccess();
  }

  return (
    <div className="w-full max-w-md px-8 pt-8 space-y-6 bg-card-background rounded-xl font-sans">
      {step === 1 && <NomineeLoginStep01 next={handleNomineeLogin} />}
      {step === 2 && <NomineeLoginStep02 accounts={accounts} next={handleAccountSelect} onBack={handleBackToLogin} />}
      {step === 3 && <NomineeLoginStep03 userId={selectedAccountId} next={handleFileUploadAndVerified} onBack={handleBackToLogin} />}
    </div>
  );
};

export default NomineeLogin;
